var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSplitBranchIcon = function SvgSplitBranchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#split-branch-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "M31 0H21a1 1 0 0 0-.708 1.708l3.586 3.584-3.292 3.294a2.002 2.002 0 0 0 .632 3.29 2 2 0 0 0 2.196-.462l3.294-3.292 3.584 3.586A1 1 0 0 0 32 11V1a1 1 0 0 0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADADAD",
    d: "m8.122 5.292 3.586-3.584A1 1 0 0 0 11 0H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1.708.708l3.584-3.586L14 16.828V30a2 2 0 0 0 4 0V16a2 2 0 0 0-.586-1.414z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "split-branch-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgSplitBranchIcon;